









import {Component, Prop, Vue} from "vue-property-decorator";
import {mapState} from "vuex";
import XDataTable from "../hoc/Table.vue";
import {OrganizationEvents} from "@/models/organization";
import moment from "moment";

@Component({
  components: {XDataTable},
  computed: {
    ...mapState({contract: "contract"}),
  },
})
class EventsTable extends Vue {
  [x: string]: any;

  @Prop({required: true}) readonly eventsList!: OrganizationEvents[];
  @Prop({required: true}) readonly reportType!: string;
  @Prop({required: true}) readonly selectedDate!: string;

  headersDay = [
    { text: "Время", value: "датавремя", width: "15%" },
    { text: "Тип", value: "код", width: "15%" },
    { text: "Событие", value: "назвсобытия" },
  ];
  headersMonth = [
    { text: "Время", value: "датавремя", width: "15%" },
    { text: "Тип", value: "код", width: "15%" },
    { text: "Событие", value: "назвсобытия" },
  ];

  get preparedHeaders() {
    if (this.reportType == 'month') {
      return this.headersMonth;
    } else {
      return this.headersDay;
    }
  }

  get preparedEventsList(): Array<string[]> {
    return this.eventsList.filter(item =>
      moment(item.датавремя).format('DD.MM.YYYY') == moment(this.selectedDate).format('DD.MM.YYYY') ||
      this.reportType == 'month'
    ).map(item => {
      return [
        this.reportType == 'month' ?
          moment(item.датавремя).format('DD.MM.YYYY HH:mm:ss') :
          moment(item.датавремя).format('HH:mm:ss'),
        item.код,
        item.назвсобытия,
      ];
    });
  }
}

export default EventsTable;
